<template>
    <div>

        <menu-bar/>

        <div class="container" role="main">
            <div class="row" style="margin-top: 50px">

                <ol class="breadcrumb">
                    <li class="active">ALERTAS :: ONUs OFFLINE</li>
                </ol>



                <div class="panel panel-info" v-if="contratos.length">
                    <div class="panel-heading">
                        <i class="fa fa-toggle-off" aria-hidden="true"></i> ONUs OFFLINE
                    </div>
                    <div class="panel-body" >

                        <div class="row">

                            <div class="col-md-4">
                                <button class="btn-sm btn btn-success" @click="loadComandos()">
                                    ATUALIZAR LISTAGEM
                                </button>
                            </div>
                            <div class="col-md-8">
                                <blockquote class="blockquote-reverse">
                                    Total de Offlines: <b>{{ contratos.length }}</b>
                                </blockquote>
                            </div>

                        </div>

                        <table id="mytable" class="table table-bordred table-striped">

                            <thead>

                                <tr>
                                    <th>NOME DA ONU</th>
                                    <th style="text-align: center;width: 120px">MAC DA ONU</th>
                                    <th style="text-align: center;width: 150px">PORTA PON</th>
                                    <th style="text-align: center;width: 150px">DATA OFFLINE</th>
                                    <th style="text-align: center;width: 90px">AÇÔES</th>
                                </tr>

                            </thead>

                            <tbody>

                                <tr v-for="r in contratos" v-bind:key="r._id">
                                    <td>
                                        {{ r.nome }}<br/>
                                        <b>Motivo</b>: <small>{{ r.info.status }}</small>
                                    </td>
                                    <td style="text-align: center">{{ r.onu_mac }}</td>
                                    <td style="text-align: center">{{ r.porta_pon.nome }}</td>
                                    <td style="text-align: center">{{ r.info.offline_time | date('DD/MM/YYYY HH:mm:ss') }}</td>

                                    <td style="text-align: center">
                                        <a :href="'#/caixa-pacpon/add/' + r._id" class="btn btn-info btn-xs">
                                            ABRIR <i class="fa fa-angle-double-right" aria-hidden="true"></i>
                                        </a>
                                    </td>
                                </tr>

                            </tbody>

                        </table>

                    </div>

                </div>

                <div class="page-header" v-if="!contratos.length && buscado">
                    <h1 style="color: darkblue">
                        <i class="fa fa-child" aria-hidden="true"></i>
                        <i class="fa fa-sign-language" aria-hidden="true"></i>
                        Boas Notícias! <small>Nenhuma ONU offline no momento.</small></h1>
                </div>

                <div class="page-header" v-if="!buscado">
                    <h1 style="color: #0c5460">
                        <i class="fa fa-angle-down" aria-hidden="true"></i>
                        Buscando ONUs Offline!!</h1>
                </div>

            </div>
        </div>

    </div>
</template>
<script>
import { CaixaPacPon } from "../class/caixa-pacpon";
import { date } from "../filters";

export default {
    filters: {
        date
    },
    data() {
        return {
            buscado: false,
            contratos: [],
            user: null,
            interval: null
        };
    },
    beforeMount() {
        this.user = this.$store.state.user;
        this.$parent.$on("comandos", () => {
            this.loadComandos();
        });
    },
    mounted() {
        this.loadComandos();
        this.interval = setInterval(this.loadComandos, 120000);
    },
    beforeDestroy() {
        if (this.interval) {
            clearInterval(this.interval);
        }
    },
    methods: {
        async loadComandos() {
            let res = await CaixaPacPon.offline();
            this.buscado = true;
            this.contratos = res.caixas;
        }
    }
};
</script>
